﻿$.fn.dxCtrlPagePlanitiReunionExterneChoixAnnulation = function custom_dxCtrlPagePlanitiReunionExterneChoixAnnulation(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlpageplanitireunionexternechoixannulation dx-ctrl");
        this.createInstance(new cdxCtrlPagePlanitiReunionExterneChoixAnnulation(this, option));
    }
    return this;
}

window.cdxCtrlPagePlanitiReunionExterneChoixAnnulation = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    var dataPlanitiReunion = null

    var dxNomStructure = null
    var dxNomPrenom = null
    var dxEmail = null
    var dxAdrPostale = null
    var dxSiteWeb = null
    var dxTelFixe = null
    var dxMobile = null
    var dxTagBoxInvite = null
    var dxLieu = null
    var dxTextInfo = null
    function mConstruit() {
        container.empty();
        container.css("position", "relative")
        container.css("text-align", "left")

        mRempli()
        if (typeof option.onContentReady != 'undefined') option.onContentReady({ component: Me })

    }

    var dxTextAnnulation = null
    function mRempli() {
        var $DivContainer = $("<div style='margin-left:40px;'/>").appendTo(container)

        $("" +
            "<div style='padding-bottom:10px;'>" +
            "<div style='font-size:160%;font-weight:bold;'>Annuler la réunion</div>" +
            "<div style='opacity:0.3;text-decoration:line-through;'>DU <b>" + DevExpress.localization.formatDate(option.dateDebutOrigineAnnulation, "eeee d MMMM yyyy") + "</b> de <b>" + DevExpress.localization.formatDate(option.dateDebutOrigineAnnulation, "HH:mm") + "</b> à <b>" + DevExpress.localization.formatDate(option.dateFinOrigineAnnulation, "HH:mm") + "</b></div>" +
            "</div>" +
            "").appendTo($DivContainer)

        $("<div style='font-weight:bold;font-size:120%;margin:25px 0 5px 0;'></div>").appendTo($DivContainer)
        //$("<div style='font-style:italic;font-size:90%;'>Partager les informations qui nous permettrons de préparer la réunion.</div>").appendTo($DivContainer)
        dxTextAnnulation = $("<div/>").appendTo($DivContainer).dxCtrlTextBox({
            label: "Préciser la raison de l'annulation",
            labelMode: 'floating',
            multiline: true,
            minHeight: 150,
            value: "",
        }).dxCtrlTextBox("instance")

        $("<div style='margin:25px 0 10px 0;'/>").appendTo($DivContainer).dxCtrlButton({
            text: "Annuler la réunion",
            onClick: function (e) {
                mValideAnnulation()
            }
        })
    }

    function mValideAnnulation() {
        var dataToBeSend = {
            command: "annuleplanitireunionorga",
            id_planiti_reunion: option.idPlanitiReunion,
            id_planiti_reunion_orga: option.idPlanitiReunionOrga,
            text_annulation: dxTextAnnulation.option("value")
        }
        option.bddCtrl.mAjaxCall(dataToBeSend, function (data) {
            option.onValidateAnnulation(data.id_planiti_reunion)
        })
    }

    this.element = function () { return container; }

    mConstruit();
}